import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	Stack,
	Typography,
} from '@mui/material';
import { FC, useState } from 'react';

const OPTIONS = [
	'Batavia',
	'NAD83 / Yukon Albers',
	'NAD83(HARN) / South Carolina (ft)',
	'GDA2020 / MGA zone 56',
	'GSK-2011',
];

export type DataImportCoordinateSystemModalProps = {
	onSelect: (selected: string) => void;
	onClose: () => void;
};

export const DataImportCoordinateSystemModal: FC<
	DataImportCoordinateSystemModalProps
> = ({ onSelect, onClose }) => {
	const [selected, setSelected] = useState<string>(OPTIONS[0]!);

	return (
		<Dialog open>
			<DialogTitle>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="center"
					gap={1}
				>
					Select coordinate system
				</Stack>
			</DialogTitle>
			<DialogContent>
				<Typography variant="body2" mb={2}>
					{
						'We were not able to detect the coordinate system. Please choose the correct coordinate system from the suggestions below.'
					}
				</Typography>
				<List
					sx={{
						'& .MuiListItem-root': {
							justifyContent: 'space-between',
							px: 0,
							py: 0,
						},
					}}
				>
					{OPTIONS.map((option) => (
						<Option
							key={option}
							value={option}
							onClick={setSelected}
							isSelected={selected === option}
						/>
					))}
				</List>
			</DialogContent>
			<DialogActions sx={{ p: 3 }}>
				<Button onClick={onClose} color="inherit">
					Cancel upload
				</Button>
				<Button
					variant="contained"
					color="error"
					onClick={() => onSelect(selected)}
				>
					Select
				</Button>
			</DialogActions>
		</Dialog>
	);
};

function Option({ value = '', onClick, isSelected }) {
	return (
		<Box
			component="li"
			sx={{ userSelect: 'none' }}
			onClick={() => onClick?.(value)}
		>
			<Box
				role="button"
				sx={{
					alignItems: 'center',
					borderRadius: 1,
					color: 'var(--mui-palette-text-secondary)',
					cursor: 'pointer',
					display: 'flex',
					flex: '0 0 auto',
					gap: 1,
					p: '6px 16px',
					textDecoration: 'none',
					whiteSpace: 'nowrap',
					...(isSelected && {
						bgcolor: 'var(--mui-palette-action-selected)',
						color: 'var(--mui-palette-text-primary)',
					}),
					'&:hover': {
						...(!isSelected && {
							bgcolor: 'var(--mui-palette-action-hover)',
							color: 'var(---mui-palette-text-primary)',
						}),
					},
				}}
				tabIndex={0}
			>
				<Box sx={{ flex: '1 1 auto' }}>
					<Typography
						component="span"
						sx={{
							color: 'inherit',
							fontSize: '0.875rem',
							fontWeight: 500,
							lineHeight: '28px',
						}}
					>
						{value}
					</Typography>
				</Box>
			</Box>
		</Box>
	);
}
